(() => {
  if (window.Shopify?.designMode || window.__rayoloImageProtection) return;
  window.__rayoloImageProtection = true;

  const style = document.createElement('style');
  style.id = 'rayolo-image-protection-style';
  style.textContent = 'img,picture,svg image{-webkit-user-drag:none;-webkit-touch-callout:none}';
  document.head.appendChild(style);

  const protectImage = (event) => {
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
    const imageTarget = path.some((node) =>
      node instanceof Element && node.matches('img,picture,svg image')
    );
    if (imageTarget) event.preventDefault();
  };

  document.addEventListener('contextmenu', protectImage, true);
  document.addEventListener('dragstart', protectImage, true);
})();
